import React from 'react';
import { object } from 'prop-types';
import { I18n, getContext } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { s_share } from '@fiverr-private/fit/icons';
import SocialSharing from '../shared/SocialSharing';
import TopPanel from '../shared/TopPanel';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const ShareYourGig = (props, context) => {
    const { general } = context;
    const { gigTitle }  = general;
    const { pathParameters } = getContext();
    const { username } = pathParameters;

    return (
        <TopPanel customClass="share-your-gig">
            <Icon size={30} className="share-your-gig-icon">{s_share}</Icon>
            <header>
                <h2><I18n k={'gig_page_perseus.share_your_gig.reach'}/></h2>
                <p><I18n k={'gig_page_perseus.share_your_gig.you_got'}/></p>
            </header>
            <SocialSharing gigTitle={gigTitle}
                sellerName={username}
                isPageOwner={true}
                title={<I18n k="gig_page_perseus.share_your_gig.button_text"/>}/>
        </TopPanel>
    );
};

ShareYourGig.contextTypes = {
    general: object
};

export { ShareYourGig };
export default SafePureComponent(ShareYourGig);
